import React from 'react'
import InfoFieldGroup from '../../../utils/InfoField/InfoFieldGroup'
import Header from './header'
import ButtonSwitch from './buttonSwitch'

export default function LicenciamentoPrivilegios({ user, permissions, setPermissions }) {
  return (
    <>
      <Header header={'Licenciamento de Estabelecimento'} />
      <InfoFieldGroup
        fields={
          [
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'licenciamentoEstabelecimentoTecnico'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Licenciamento de Estabelecimento na Áre Técnica'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'licenciamentoEstabelecimentoChefeSeccao'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Licenciamento de Estabelecimento em Chefe de Secção'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'licenciamentoEstabelecimentoChefeDepartamento'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Licenciamento de Estabelecimento em Chefe de Departamento'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'licenciamentoEstabelecimentoInspeccaoAgendada'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Licenciamento de Estabelecimento em Inspecção Agendada'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'licenciamentoEstabelecimentoInspeccaoRealizada'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Licenciamento de Estabelecimento em Inspecção Realizada'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'licenciamentoEstabelecimentoDirectorGeralAdjunta'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Licenciamento de Estabelecimento em Director(a) Geral Adjunta para os Serviços Executivos'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'licenciamentoEstabelecimentoDeferimento'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Licenciamento de Estabelecimento em Aprovar Estabelecimento'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'reclamacoesLicenciamento'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Gestao de Reclamações em Licenciamento de Estabelecimento'}
                  descricao={''}
                />
              , editable: false,
            },

          ]} />
    </>
  )
}
